import {Layout} from "../../../src/ts/layouts/Layout";

export class CarouselAndText extends Layout {

    private readonly SELECTOR_GALLERY_NEXT_LINK: string = ".carousel-and-text__gallery-btn-next";
    private readonly SELECTOR_GALLERY_PREV_LINK: string = ".carousel-and-text__gallery-btn-prev";
    private readonly SELECTOR_GALLERY: string = ".carousel-and-text__gallery";
    private readonly SELECTOR_GALLERY_ITEM: string = ".carousel-and-text__gallery-list-item";
    private readonly SELECTOR_GALLERY_COUNT: string = ".carousel-and-text__gallery-count";
    private readonly SELECTOR_GALLERY_INDEX: string = ".carousel-and-text__gallery-index";

    private readonly SELECTOR_CURRENT_IMAGE: string = ".current";

    private readonly STATE_CURRENT_IMAGE: string = "current";

    private $gallery: JQuery;
    private $galleryItems: JQuery;
    private $galleryNext: JQuery;
    private $galleryPrev: JQuery;
    private $galleryIndex: JQuery;

    private $galleryCount: JQuery;

    private currentIndex: number;
    private galleryImagesCount: number;


    constructor($elem: JQuery) {
        super($elem);

        this.$galleryNext = this.$layout.find(this.SELECTOR_GALLERY_NEXT_LINK);
        this.$galleryPrev = this.$layout.find(this.SELECTOR_GALLERY_PREV_LINK);
        this.$gallery = this.$layout.find(this.SELECTOR_GALLERY);
        this.$galleryItems = this.$layout.find(this.SELECTOR_GALLERY_ITEM);
        this.galleryImagesCount = this.$galleryItems.length;
        this.$galleryCount = this.$layout.find(this.SELECTOR_GALLERY_COUNT);

        if (this.galleryImagesCount > 1) {
            this.$galleryIndex = this.$layout.find(this.SELECTOR_GALLERY_INDEX);
            this.$galleryNext.on('click', (event) => this.onGalleryNextClick(event));
            this.$galleryPrev.on('click', (event) => this.onGalleryPrevClick(event));
        } else {
            this.$galleryNext.remove();
            this.$galleryPrev.remove();
            this.$galleryCount.remove();
        }
    }

    private onGalleryNextClick(e: JQuery.ClickEvent) {


        let selectedIndex = this.$galleryItems.index(this.$galleryItems.filter(this.SELECTOR_CURRENT_IMAGE));

        this.$galleryItems.removeClass(this.STATE_CURRENT_IMAGE);

        if (selectedIndex + 1 >= this.galleryImagesCount) {
            selectedIndex = 0;
        } else {
            selectedIndex++;
        }

        console.log('selectedIndex after addition ' + selectedIndex);
        this.$galleryItems.eq(selectedIndex).addClass(this.STATE_CURRENT_IMAGE);
        this.currentIndex = selectedIndex + 1;
        this.updateIndex();
        return false;
    }

    private onGalleryPrevClick(e: JQuery.ClickEvent) {
        let selectedIndex = this.$galleryItems.index(this.$galleryItems.filter(this.SELECTOR_CURRENT_IMAGE));

        this.$galleryItems.eq(selectedIndex).removeClass(this.STATE_CURRENT_IMAGE);

        if (selectedIndex - 1 < 0) {
            selectedIndex = this.galleryImagesCount - 1;
        } else {
            selectedIndex--;
        }

        this.$galleryItems.eq(selectedIndex).addClass(this.STATE_CURRENT_IMAGE);
        this.currentIndex = selectedIndex + 1;
        this.updateIndex();
        return false;
    }

    private updateIndex() {
        this.$galleryIndex.text(this.currentIndex);
    }
}

